/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { getControllerFromRoute } from '@/helper/RouteHelper';
import { resolveEffectivePathname } from '@/components/PhanHe/VanHoaPhanHeHandler';
import { useAuthStore } from '@/store/useAuthStore';
import { usePrivateStore } from '@/store/usePrivateStore';
import { Avatar, Badge, message, Tooltip } from 'antd';
import { AppstoreOutlined, CheckCircleOutlined, CloseCircleOutlined, SyncOutlined, UserOutlined } from '@ant-design/icons';
import * as signalR from '@microsoft/signalr';
import { useRouter } from 'next/router';
import { useEffect, useLayoutEffect, useMemo, useRef, useState, useCallback } from 'react';
import { useRecoilValue } from 'recoil';
import { headerScrollHideEnabledState } from '@/states/headerPreference';
import { YearSelectorBSC } from '../common/YearSelectorBSC';
import { HEADER_ROUTES, TREE_SELECT_ROUTES, isHideOrgTreePath, isLogfilesPath } from '../../configs/ROUTE_HEADER';
import { logfilesOrgFilterEnabledState } from '@/states/logfilesOrgFilter';
import { ROUTES } from '@/utils/pathRoutes';
import { notifyLogoutAcrossTabs } from '@/utils/authCrossTabSync';
import { DropDownDepartment } from './DropDownDepartment';
import { DropDownKiemNhiem } from './DropDownKiemNhiem';
import { CoCauHistorySelector } from './CoCauHistorySelector';
import HelpIcon from '../common/HelpIcon';
import HelpModal from '../common/HelpModal';
import {
    isVanHoaHuongDanController,
    isVanHoaPath,
    mapFeControllerToVhHuongDanKey,
    resolveVhHuongDanFromPath,
    VH_HUONG_DAN_DEFAULT_TARGET,
} from '@/utils/vanHoaHuongDan';
import { useRealtimeStore } from '@/store/RealtimeStore';
import { useCoCauGiaiDoanConfigEnabled } from '@/hooks/useCoCauGiaiDoanConfigEnabled';
import { signalRService } from '@/services/signalR';
import CommonJs from '@/utils/commonJs';
import IntlMessages from '../Locale/IntlMessages';
import { BellIcon } from '../Icons/NavbarIcon';
import { ProfileDrawer } from './ProfileDrawer';
import { NotifyDrawer } from './NotifyDrawer';
import { Buoc6ChiTieuWarningHeaderNotify } from './Buoc6ChiTieuWarningHeaderNotify';
import { KPIConsecutiveFailHeaderNotify } from './KPIConsecutiveFailHeaderNotify';
import { OpenTabCount } from './OpenTabCount';
import { ActionPlanAssignBanner } from './ActionPlanAssignBanner';
import { notifyApi } from '@/services/notify/notify-api';
// import { authApi, parseUserProfileResponse } from '@/services/authen';
// import { fetchInitDataOrganization } from '@/utils/organizationIndexedDBUtils';
import { syncLoggedInUserPermissionsAfterRoleGroupChange } from '@/utils/organizationIndexedDBUtils';
import requestManager from '@/services/request-manager';
import { useActionPlanAssignBannerStore } from '@/store/actionPlanAssignBannerStore';
import {
  shouldShowActionPlanAssignBanner,
  isDuAnIndexPage,
} from '@/components/common/ActionPlan/utils/actionPlanAssignNotify';
import { CONSTANTS } from '@/utils/constants';
import { isHeaderScrollUpShowPath } from '@/constants/headerhideScrolling';
import { clearCongViecDuAnSession } from '@/components/common/ActionPlan/utils/du-an-utils';
import { useCopyDataProgressStore } from '@/store/copyDataProgressStore';
import { getCopyDataLockedYearsForController } from '@/utils/copyDataYearLock';
// import { initPrivateStoreAfterOrgLoad } from '@/utils/initPrivateStoreAfterOrgLoad';
// import { useClearCache } from '../../hooks/useClearCache';
// import { isHeaderHideScrollingPath } from '@/constants/headerhideScrolling';

const pendingNotificationCountRequests = new Map<string, Promise<any>>();

const getNotificationCountOnce = (toID: string) => {
    const pending = pendingNotificationCountRequests.get(toID);
    if (pending) return pending;

    const request = notifyApi.counter({ toID, action: null }).finally(() => {
        if (pendingNotificationCountRequests.get(toID) === request) {
            pendingNotificationCountRequests.delete(toID);
        }
    });
    pendingNotificationCountRequests.set(toID, request);
    return request;
};

export const Header: React.FC = () => {
    const [toggle, setToggle] = useState<boolean>(false);
    const [showNotifyDrawer, setShowNotifyDrawer] = useState<boolean>(false);
    const [showHelpModal, setShowHelpModal] = useState<boolean>(false);
    const [helpModalController, setHelpModalController] = useState<string | null>(null);
    const [vhHelpStrcontroller, setVhHelpStrcontroller] = useState<string>('');
    const [vhHelpTarget, setVhHelpTarget] = useState<string | undefined>(undefined);
    const [yeuToThanhCongNganhData, setYeuToThanhCongNganhData] = useState<
        Array<{ id: string; noiDung?: string;[key: string]: unknown }>
    >([]);
    const [notifyCount, setNotifyCount] = useState<number>(0);
    // const [notifyList, setNotifyList] = useState<any[]>([]);
    // const { clearCache } = useClearCache();
    const router = useRouter();
    const { profile, tenantID } = useAuthStore();
    const switchingPhanHeRef = useRef(false);

    /** Nút chuyển PH → sync profile rồi /intro (cùng rule logo Navbar). */
    const goSwitchPhanHe = useCallback(async () => {
        if (switchingPhanHeRef.current) return;
        if (
            router.pathname === ROUTES.INTRO ||
            router.asPath.startsWith(`${ROUTES.INTRO}/`)
        ) {
            return;
        }

        switchingPhanHeRef.current = true;
        const hideLoadingMsg = message.loading('Đang tải dữ liệu...', 0);
        try {
            await syncLoggedInUserPermissionsAfterRoleGroupChange();
            await router.push(ROUTES.INTRO);
        } catch (error) {
            console.error('[header] switch phan he failed', error);
            message.error('Có lỗi xảy ra, vui lòng thử lại');
        } finally {
            hideLoadingMsg();
            switchingPhanHeRef.current = false;
        }
    }, [router]);
    const { giaiDoan, setGiaiDoan, coCauHistory, clearCoCauHistory } = usePrivateStore();
    const { enabled: coCauGiaiDoanEnabled, loading: coCauGiaiDoanConfigLoading } =
        useCoCauGiaiDoanConfigEnabled();
    const initialLetter = useMemo(() => {
        const name = (profile?.tenNhanVien || '').trim();
        if (!name) return '?';

        const parts = name.split(/\s+/).filter(Boolean);
        const first = parts[0]?.charAt(0) || '';
        const last = parts.length > 1 ? (parts[parts.length - 1]?.charAt(0) || '') : '';
        return (first + last).toUpperCase() || '?';
    }, [profile?.tenNhanVien]);
    const normalizedPathname = router.pathname.split('?')[0].split('#')[0].replace(/\/$/, '') || '/';
    const controllerPath = normalizedPathname === '/404'
        ? resolveEffectivePathname(router.pathname, router.asPath)
        : router.pathname;
    const controller = getControllerFromRoute(controllerPath);
    const isKPINgoaiLePage = typeof router?.pathname === 'string' && router.pathname.includes('kpi-ngoai-le');
    // State cho YearSelectorBSC - mặc định lấy năm hiện tại
    const currentYear = parseInt(new Date().getFullYear().toString() || '0');
    const [selectedStage, setSelectedStage] = useState<{
        idGiaiDoan: string | null;
        year: number | null;
        namTaiChinh?: boolean;
        startDate?: string | null;
        endDate?: string | null;
    }>({
        idGiaiDoan: null,
        year: currentYear,
        namTaiChinh: false,
        startDate: null,
        endDate: null,
    });
    const hasInitializedRef = useRef(false);
    const headerElRef = useRef<HTMLElement | null>(null);
    const [headerPinned, setHeaderPinned] = useState(true);
    const headerPinnedRef = useRef(true);

    const isHideHeaderPage = useRecoilValue(headerScrollHideEnabledState);
    const isBuoc5ScrollUpShow = isHeaderScrollUpShowPath(router.pathname);

    useEffect(() => {
        if (!isHideHeaderPage) {
            setHeaderPinned(true);
            headerPinnedRef.current = true;
        }
    }, [isHideHeaderPage]);

    useLayoutEffect(() => {
        if (!isHideHeaderPage) {
            return;
        }
        const header = headerElRef.current;
        const main = header?.closest('main');
        if (!main) {
            return;
        }
        const SHOW_THRESHOLD = 56;
        const HEADER_H = 56;
        const SCROLL_DELTA_MIN = 4;
        let lastScrollTop = main.scrollTop;
        const onScroll = () => {
            const nextScrollTop = Math.max(0, main.scrollTop);
            const delta = nextScrollTop - lastScrollTop;
            let nextPinned = headerPinnedRef.current;

            if (nextScrollTop <= SHOW_THRESHOLD) {
                nextPinned = true;
            } else if (isBuoc5ScrollUpShow && delta < -SCROLL_DELTA_MIN) {
                // Bước 5: cuộn lên → hiện header
                nextPinned = true;
            } else if (
                isBuoc5ScrollUpShow
                    ? delta > SCROLL_DELTA_MIN && nextScrollTop >= HEADER_H
                    : delta > 0 && nextScrollTop >= HEADER_H
            ) {
                nextPinned = false;
            }

            lastScrollTop = nextScrollTop;

            if (nextPinned !== headerPinnedRef.current) {
                headerPinnedRef.current = nextPinned;
                setHeaderPinned(nextPinned);
            }
        };
        onScroll();
        main.addEventListener('scroll', onScroll, { passive: true });
        return () => main.removeEventListener('scroll', onScroll);
    }, [isHideHeaderPage, isBuoc5ScrollUpShow, router.pathname]);

    // // Hàm reload data vào IndexedDB (tương tự như trong login page)
    // const reloadInitData = async () => {
    //     try {
    //         if (!tenantID) {
    //             console.warn('SignalRIndexedDBSync: No tenantID, skipping reload');
    //             return;
    //         }
    //         // Giữ lại bộ phận đang chọn (ưu tiên sessionStorage của getRequestHeader) để không bị reset về mặc định.
    //         const preferredSelectId = usePrivateStore.getState().getRequestHeader?.()?.selectTree?.idSelected

    //         const { clearGlobalCache } = await import('@/hooks/useOrganizationIndexedDB');
    //         await clearGlobalCache();
    //         const [, responseProfile]: any = await Promise.all([
    //             fetchInitDataOrganization(),
    //             authApi.requestUserProfile(profile?.id || '', phanHe),
    //         ]);
            
    //         if (typeof window !== 'undefined') {
    //             window.dispatchEvent(new CustomEvent('indexedDBReloaded'));
    //         }

    //         // Nếu không có bộ phận đang chọn, hoặc bộ phận đã không còn trong phạm vi quyền module, fallback mặc định.
    //         await initPrivateStoreAfterOrgLoad({
    //             profile,
    //             tenantID,
    //             controller,
    //             preferredSelectId: preferredSelectId || null,
    //         });

    //         const nextProfile = parseUserProfileResponse(responseProfile);
    //         if (nextProfile) {
    //             useAuthStore.getState().setIsAuth(true);
    //             useAuthStore.getState().setProfile(nextProfile);
    //         }

    //     } catch (error) {
    //         console.error('❌ SignalRIndexedDBSync: Error reloading initData:', error);
    //     }
    // };

    // Realtime updates via RealtimeStore
    const invalidateNotifications = useRealtimeStore((state) => state.invalidate.notifications);
    const notificationData = useRealtimeStore((state) => state.notificationData);
    const connectionState = useRealtimeStore((state) => state.connectionState);

    // Reload notifications when invalidated
    useEffect(() => {
        if (invalidateNotifications) {
            loadBadgeNotifyData();
        }
    }, [invalidateNotifications]);

    // Track notification đã hiển thị để tránh hiển thị lại khi re-render
    const displayedNotificationsRef = useRef<Set<string>>(new Set());

    // Display SignalR notifications
    useEffect(() => {
        if (notificationData.lastNotification) {
            console.log('notificationData.lastNotification =>>>>', notificationData.lastNotification);
            const notification = notificationData.lastNotification;

            // Tạo unique ID cho notification
            const notificationId = `${notification.type || ''}_${notification.title || ''}_${notification.timestamp || ''
                }_${JSON.stringify(notification.data || {})}`;

            // Kiểm tra xem notification đã được hiển thị chưa
            if (displayedNotificationsRef.current.has(notificationId)) {
                return; // Đã hiển thị rồi, bỏ qua
            }

            // Đánh dấu đã hiển thị
            displayedNotificationsRef.current.add(notificationId);

            // Giới hạn size của Set để tránh memory leak (giữ tối đa 100 notification)
            if (displayedNotificationsRef.current.size > 100) {
                const firstKey = displayedNotificationsRef.current.values().next().value;
                displayedNotificationsRef.current.delete(firstKey || '');
            }

            // Show notification based on type
            const notificationType = notification.type?.toLowerCase() || '';

            if (notificationType.includes('error') || notificationType.includes('danger')) {
                message.error({
                    content: notification.body || notification.title || 'Có lỗi xảy ra',
                    duration: 5,
                    key: notificationId, // Sử dụng key để tránh duplicate
                });
            } else if (notificationType.includes('success')) {
                message.success({
                    content: notification.body || notification.title || 'Thành công',
                    duration: 3,
                    key: notificationId,
                });
            } else if (notificationType.includes('warning')) {
                message.warning({
                    content: notification.body || notification.title || 'Cảnh báo',
                    duration: 4,
                    key: notificationId,
                });
            } else if (notificationType === 'reload_license') {
                //const handleClearCache = async () => {
                //    try {
                //        await clearCache();
                //    } catch (error) {
                //        console.error('Clear cache error', error);
                //    }
                //};
                //handleClearCache();

            }
            else if (notificationType === 'reload_action_plan_assign') {
                if (!shouldShowActionPlanAssignBanner(notification, router)) return;
                clearCongViecDuAnSession();
                const notifyMsg = CONSTANTS.ACTION_PLAN.NOTIFY;
                const onDuAnPage = isDuAnIndexPage(router.pathname);
                const bannerBody = onDuAnPage
                    ? (notification.body || '').trim() || notification.title || notifyMsg.FALLBACK_TITLE
                    : notification.body || notifyMsg.FALLBACK_BODY;
                useActionPlanAssignBannerStore.getState().showBanner({
                    dedupeKey: `action-plan-assign-${notification.data?.idSelect || ''}-${notification.data?.idDuAn || ''}`,
                    title: notification.title || notifyMsg.FALLBACK_TITLE,
                    body: bannerBody,
                });
            }
            else if (notificationType !== 'reload_license') {
                const title = notification.body || notification.title || undefined;
                if (title && title !== '') {
                    // Default: show info notification
                    message.info({
                        content: notification.body || notification.title || CONSTANTS.ACTION_PLAN.NOTIFY.FALLBACK_GENERIC,
                        duration: 3,
                        key: notificationId,
                    });
                }
            }
        }
    }, [notificationData.lastNotification]);

    // Track previous connection state to show notifications on change
    const prevConnectionStateRef = useRef<signalR.HubConnectionState | null>(null);

    // Poll connection state periodically to keep UI in sync
    useEffect(() => {
        const updateConnectionState = () => {
            const store = useRealtimeStore.getState();
            const currentState = signalRService.getConnectionState();
            const currentId = signalRService.getConnectionId();
            const currentIsConnected = signalRService.isConnectionActive();

            // Check if state changed
            const stateChanged =
                store.connectionState.state !== currentState ||
                store.connectionState.connectionId !== currentId ||
                store.connectionState.isConnected !== currentIsConnected;

            if (stateChanged) {
                const prevState = prevConnectionStateRef.current;
                prevConnectionStateRef.current = currentState;

                store.setConnectionState(currentIsConnected, currentState, currentId);

                // Show notification on state change
                if (prevState !== null) {
                    if (currentState === signalR.HubConnectionState.Connected) {
                        message.success({
                            content: 'Đã kết nối SignalR thành công',
                            duration: 3,
                            key: 'signalr-connection',
                        });
                    } else if (currentState === signalR.HubConnectionState.Disconnected) {
                        message.warning({
                            content: 'Đã ngắt kết nối SignalR',
                            duration: 3,
                            key: 'signalr-connection',
                        });
                    } else if (currentState === signalR.HubConnectionState.Reconnecting) {
                        message.info({
                            content: 'Đang kết nối lại SignalR...',
                            duration: 2,
                            key: 'signalr-connection',
                        });
                    }
                }
            }
        };

        // Initial update
        updateConnectionState();

        // Update every 2 seconds
        const interval = setInterval(updateConnectionState, 2000);

        return () => clearInterval(interval);
    }, []);

    // Listen for yeuToThanhCongNganhData updates from EvaluatePage
    useEffect(() => {
        const handleYeuToThanhCongNganhDataUpdate = (event: CustomEvent) => {
            setYeuToThanhCongNganhData(event.detail.data || []);
        };

        window.addEventListener('yeuToThanhCongNganhDataUpdate', handleYeuToThanhCongNganhDataUpdate as EventListener);

        return () => {
            window.removeEventListener('yeuToThanhCongNganhDataUpdate', handleYeuToThanhCongNganhDataUpdate as EventListener);
        };
    }, []);

    // Listen for open-vanhoa-help-modal (toolbar tourguide VH)
    useEffect(() => {
        const handleOpenVanHoaHelpModal = (event: CustomEvent) => {
            const strcontroller = event.detail?.strcontroller;
            const target = event.detail?.target;
            if (!strcontroller) return;
            setVhHelpStrcontroller(strcontroller);
            setVhHelpTarget(target);
            setShowHelpModal(true);
        };

        window.addEventListener('open-vanhoa-help-modal', handleOpenVanHoaHelpModal as EventListener);

        return () => {
            window.removeEventListener('open-vanhoa-help-modal', handleOpenVanHoaHelpModal as EventListener);
        };
    }, []);

    // Listen for open-help-modal event from Navbar
    useEffect(() => {
        const handleOpenHelpModal = (event: CustomEvent) => {
            const controller = event.detail?.controller || 'phongcach';
            if (controller) {
                setShowHelpModal(true);
                // Store controller in a ref or state to override the route-based controller
                setHelpModalController(controller);
            }
        };

        window.addEventListener('open-help-modal', handleOpenHelpModal as EventListener);

        return () => {
            window.removeEventListener('open-help-modal', handleOpenHelpModal as EventListener);
        };
    }, []);

    const loadBadgeNotifyData = async () => {
        try {
            const toID = profile?.id;
            if (!toID) return;

            const res: any = await getNotificationCountOnce(toID);
            const data = res?.data?.data ?? res?.data ?? res;

            // Backend response shape may vary; support array or { items, total, unreadCount }
            const items = Array.isArray(data)
                ? data
                : Array.isArray(data?.items)
                    ? data.items
                    : Array.isArray(data?.list)
                        ? data.list
                        : [];

            // setNotifyList(items);

            const unreadCount =
                typeof data?.unread === 'number' ? data.unread : items.filter((x: any) => x?.read === false).length;

            setNotifyCount(unreadCount);
        } catch (err) {
            console.warn('loadNotifyData failed:', err);
        }
    };

    // Load notification count on mount / profile change
    useEffect(() => {
        loadBadgeNotifyData();
    }, [profile?.id]);

    // Handler cho YearSelectorBSC
    const handleStageChange = (value: {
        idGiaiDoan: string;
        year: number;
        namTaiChinh?: boolean;
        startDate?: string | null;
        endDate?: string | null;
    }) => {
        setSelectedStage(value);

        // Lưu idGiaiDoan và selectedYear vào store toàn cục
        setGiaiDoan(
            value.idGiaiDoan,
            value.year,
            null,
            value.namTaiChinh || false,
            value.startDate || null,
            value.endDate || null
        );
    };

    const handleLogout = async () => {
        requestManager.cancelAll();
        notifyLogoutAcrossTabs();
        router.push(ROUTES.LOGOUT);
    };

    const handleShowHelp = () => {
        if (isVanHoaPath(controllerPath)) {
            const resolved = resolveVhHuongDanFromPath(controllerPath);
            const strcontroller = resolved.strcontroller || mapFeControllerToVhHuongDanKey(controller ?? '', controllerPath);
            setVhHelpStrcontroller(strcontroller);
            setVhHelpTarget(resolved.defaultTarget || VH_HUONG_DAN_DEFAULT_TARGET[strcontroller]);
        }
        setShowHelpModal(true);
    };

    // Khởi tạo selectedStage từ store khi component mount
    useEffect(() => {
        if (!hasInitializedRef.current) {
            if (giaiDoan.id && !selectedStage.idGiaiDoan) {
                setSelectedStage((prev) => ({
                    ...prev,
                    idGiaiDoan: giaiDoan.id,
                }));
            }
            if (giaiDoan.year && !selectedStage.year) {
                setSelectedStage((prev) => ({
                    ...prev,
                    year: giaiDoan.year,
                }));
            }
            hasInitializedRef.current = true;
        }
    }, [giaiDoan, selectedStage.idGiaiDoan, selectedStage.year]);

    const shouldUseYearSelectHeaderYear = HEADER_ROUTES.YEAR_SELECT_ROUTES_YEAR.includes(controller ?? '');

    const checkListRouteYearSelect =
        HEADER_ROUTES.YEAR_SELECT_ROUTES_NO_YEAR.includes(controller ?? '') ||
        HEADER_ROUTES.YEAR_SELECT_ROUTES_YEAR.includes(controller ?? '');
    const checkListRouteHuongDan = isVanHoaPath(controllerPath)
        ? isVanHoaHuongDanController(controller)
        : HEADER_ROUTES.HUONG_DAN_ROUTES.includes(controller ?? '');


    const allowCoCauHistoryHeader =
        coCauGiaiDoanEnabled &&
        !coCauGiaiDoanConfigLoading &&
        (controller === 'dashboard' ||
            controller === 'buoc4' ||
            controller === 'buoc5' ||
            controller === 'buoc6' ||
            controller === 'buoc7' ||
            router.pathname === '/ban-do-chien-luoc');
    const logfilesOrgFilterEnabled = useRecoilValue(logfilesOrgFilterEnabledState);
    const hideLogfilesOrgTree = isLogfilesPath(controllerPath) && !logfilesOrgFilterEnabled;
    const copyDataPhase = useCopyDataProgressStore((s) => s.phase);
    const copyDataDenNam = useCopyDataProgressStore((s) => s.denNam);
    const copyDataSteps = useCopyDataProgressStore((s) => s.steps);
    const copyDataLockedYears = useMemo(
        () =>
            getCopyDataLockedYearsForController(controller, {
                phase: copyDataPhase,
                denNam: copyDataDenNam,
                steps: copyDataSteps,
            }),
        [controller, copyDataPhase, copyDataDenNam, copyDataSteps]
    );
    const availableHeader =
        TREE_SELECT_ROUTES.includes(controller ?? '') &&
        !isHideOrgTreePath(controllerPath) &&
        !hideLogfilesOrgTree;

    useEffect(() => {
        if (coCauHistory.enabled && !allowCoCauHistoryHeader) {
            clearCoCauHistory();
        }
    }, [allowCoCauHistoryHeader, clearCoCauHistory, coCauHistory.enabled]);

    if (!controller) return;

    return (
        <>
            <div className="h-2 bg-[#F5F6F8] z-32 sticky right-0 left-0 top-0 mx-[-15px]" />
            <header
                ref={headerElRef}
                className={[
                    'z-32 sticky right-0 left-0 top-2 justify-between flex items-center mx-[-16px] px-[16px] bg-[#F5F6F8]',
                    isHideHeaderPage
                        ? `h-[56px] will-change-transform transition-all duration-200 ease-linear ${headerPinned
                            ? 'translate-y-0 opacity-100'
                            : 'translate-y-[calc(-100%-8px)] opacity-0 pointer-events-none'
                        }`
                        : 'h-[56px]',
                ].join(' ')}
            >
                <div className='bg-white rounded-lg flex items-center justify-between w-full px-[16px]'>
                    <div className="flex-1 flex items-center gap-x-2">
                        {profile && tenantID && availableHeader && (
                            <>
                                <div className="text-1c252e font-semibold">
                                    <IntlMessages id="bsc.label.tochuc" text="Tổ chức:" />
                                </div>
                                {/* ===== Tree Select Department ===== */}
                                <DropDownDepartment profile={profile} tenantID={tenantID} />
                            </>
                        )}

                        {/* ===== Year Selector ===== */}
                        {checkListRouteYearSelect && !isKPINgoaiLePage && (
                            <div className={shouldUseYearSelectHeaderYear ? 'w-auto max-w-[140px]' : 'w-fit max-w-[220px]'}>
                                <YearSelectorBSC
                                    onChange={handleStageChange}
                                    yearSelected={selectedStage.year || currentYear}
                                    isShowYear={shouldUseYearSelectHeaderYear}
                                    getPopupContainer={() => document.body}
                                    disabledYears={copyDataLockedYears}
                                />
                            </div>
                        )}
                        {allowCoCauHistoryHeader ? (
                            <CoCauHistorySelector year={giaiDoan.year || selectedStage.year || currentYear} />
                        ) : null}
                    </div>
                    <div className="flex justify-end items-center">
                        {/* ===== Help Icon ===== */}
                        {checkListRouteHuongDan && <HelpIcon onClick={handleShowHelp} />}

                        {/* ===== SignalR Connection Status ===== */}
                        <Tooltip
                            title={
                                connectionState.state === signalR.HubConnectionState.Connected
                                    ? `Đã kết nối (${connectionState.connectionId?.substring(0, 8) || 'N/A'})`
                                    : connectionState.state === signalR.HubConnectionState.Connecting
                                        ? 'Đang kết nối...'
                                        : connectionState.state === signalR.HubConnectionState.Reconnecting
                                            ? 'Đang kết nối lại...'
                                            : 'Đã ngắt kết nối'
                            }
                            placement="bottom"
                        >
                            <div className="flex items-center gap-x-1 mr-2 px-2 py-1 rounded-md" style={{ display: 'none' }}>
                                {connectionState.state === signalR.HubConnectionState.Connected ? (
                                    <CheckCircleOutlined className="text-green-500 text-sm" />
                                ) : connectionState.state === signalR.HubConnectionState.Connecting ||
                                    connectionState.state === signalR.HubConnectionState.Reconnecting ? (
                                    <SyncOutlined className="text-yellow-500 text-sm animate-spin" />
                                ) : (
                                    <CloseCircleOutlined className="text-red-500 text-sm" />
                                )}
                                <span
                                    className={`text-xs ${connectionState.state === signalR.HubConnectionState.Connected
                                        ? 'text-green-600'
                                        : connectionState.state === signalR.HubConnectionState.Connecting ||
                                            connectionState.state === signalR.HubConnectionState.Reconnecting
                                            ? 'text-yellow-600'
                                            : 'text-red-600'
                                        }`}
                                >
                                    {connectionState.state === signalR.HubConnectionState.Connected
                                        ? 'Online'
                                        : connectionState.state === signalR.HubConnectionState.Connecting
                                            ? 'Đang kết nối...'
                                            : connectionState.state === signalR.HubConnectionState.Reconnecting
                                                ? 'Đang kết nối lại...'
                                                : 'Offline'}
                                </span>
                            </div>
                        </Tooltip>

                        <div className="flex items-center gap-x-4 mr-4">
                            <OpenTabCount />
                            <Tooltip title="Chuyển phân hệ" placement="bottom">
                                <div
                                    className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-[#F4F6F8] text-[#595959] transition-colors duration-200 hover:bg-[#E4E7EB]"
                                    onClick={() => {
                                        void goSwitchPhanHe();
                                    }}
                                    role="button"
                                    tabIndex={0}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            void goSwitchPhanHe();
                                        }
                                    }}
                                >
                                    <AppstoreOutlined style={{ fontSize: 20 }} />
                                </div>
                            </Tooltip>
                            <Buoc6ChiTieuWarningHeaderNotify enabled={!!profile} />
                            <KPIConsecutiveFailHeaderNotify enabled={!!profile} />
                            <ActionPlanAssignBanner />
                            <Badge count={notifyCount}>
                                <div
                                    className="cursor-pointer transition-transform duration-200 hover:scale-110 hover:-translate-y-0.5"
                                    onClick={() => {
                                        setShowNotifyDrawer(true);
                                        loadBadgeNotifyData();
                                    }}
                                >
                                    <BellIcon />
                                </div>
                            </Badge>
                        </div>

                        {/* ===== Profile Section ===== */}
                        <div className="flex items-center gap-x-[7px]">
                            {/* Dropdown Kiêm nhiệm */}
                            <DropDownKiemNhiem />
                            <div
                                className="flex justify-center items-center gap-3 w-[50px] h-[50px] relative cursor-pointer transition-shadow duration-200 hover:shadow-lg rounded-full"
                                onClick={() => setToggle(!toggle)}
                            >
                                <div
                                    className="w-[40px] h-[40px] rounded-full p-[4px]"
                                    style={{ background: 'linear-gradient(135deg, #FFAB00 0%, #0C68E9 100%)' }}
                                >
                                    {profile?.avatar ? (
                                        <Avatar
                                            src={profile.avatar}
                                            size={32}
                                            icon={<UserOutlined />}
                                            className="!w-full !h-full [&_img]:object-cover"
                                        >
                                            {initialLetter}
                                        </Avatar>
                                    ) : (
                                        <div
                                            className="w-full h-full rounded-full flex justify-center items-center text-1xl text-white overflow-hidden"
                                            style={{ backgroundColor: CommonJs.genColorByName(profile?.tenNhanVien || '') }}
                                        >
                                            {initialLetter}
                                        </div>
                                    )}
                                </div>
                            </div>
                            {/* Profile Dropdown */}
                            <ProfileDrawer isOpen={toggle} onClose={() => setToggle(false)} handleLogout={handleLogout} />
                        </div>
                    </div>
                </div>
            </header>

            {/* Notification Drawer */}
            <NotifyDrawer
                isOpen={showNotifyDrawer}
                onClose={() => setShowNotifyDrawer(false)}
                onNotificationRead={loadBadgeNotifyData}
            />

            <HelpModal
                visible={showHelpModal}
                onClose={() => {
                    setShowHelpModal(false);
                    setHelpModalController(null);
                    setVhHelpStrcontroller('');
                    setVhHelpTarget(undefined);
                }}
                controller={helpModalController || controller || undefined}
                yeuToThanhCongNganhData={yeuToThanhCongNganhData}
                useVanHoaGuide={isVanHoaPath(controllerPath)}
                vhStrController={vhHelpStrcontroller || resolveVhHuongDanFromPath(controllerPath).strcontroller}
                initialTarget={vhHelpTarget}
            />
        </>
    );
};
